import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./contact_us.css"; // Optional: For adding styles
import Qr from "../../../Assets/image/QR_sea_Sales.webp";
import { Col, Row } from "reactstrap";
import logo from "../../../Assets/image/logo.png";
import { ReactComponent as Phone } from "../../../Assets/svg/phone1-call-phone-svgrepo-com.svg";
import { ReactComponent as Message } from "../../../Assets/svg/message1-circle-lines-svgrepo-com.svg";
import Bar1 from "../../../components/navigationbar/navigationbar1";
import { Button, Input, Textarea } from "@nextui-org/react";
import ContactUs from "./Contactus";
import { body } from "framer-motion/client";
import { BASEURL } from "../../../constant/constant";
import { Link } from "react-router-dom";
import Footer from "../footer/footer";
import { Helmet } from "react-helmet";

const Contact_Us = () => {

    const phone = "918055607812";
    const message = encodeURIComponent(
        "Inquiry to your company products message"
    );
    const whatsappUrl = `https://wa.me/${phone}?text=${message}`;

    const [formData, setFormdata] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        description: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        description: '',
    })

    const handlechnage = (e) => {
        const { name, value } = e.target;
        setFormdata((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErroes) => ({
            ...prevErroes,
            [name]: '',
        }));
    };


    const validate = () => {
        const newErrors = {};

        if (!formData.name) {
            newErrors.name = 'Name is required';
        }

        if (!formData.address) {
            newErrors.address = 'Address is required';
        }

        if (!formData.phone) {
            newErrors.phone = 'Phone is required';
        } else if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = 'Phone number must be exactly 10 digits';
        }

        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Enter a valid email address';
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        const payload = {
            name: formData.name,
            address: formData.address,
            phone_no: formData.phone,  // Renamed to match backend expectation
            email: formData.email,
            description: formData.description || '', // Ensure it’s included
        };

        try {
            const response = await fetch(`${BASEURL}/api/inquiry/addInquiry`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error('Server is not response');
            }
            const result = await response.json();
        }
        catch (error) {
            console.log('APi is not responding', error);
        }
        // e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            // Submit the form data
            console.log('Form submitted:', formData);
            // Reset form
            setFormdata({
                name: '',
                address: '',
                phone: '',
                email: '',
                description: '',
            });
        }
    };

    ////////////////////////////scroll nav hide /////////////////
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY) {
            // Scrolling down
            setIsVisible(false);
        } else {
            // Scrolling up
            setIsVisible(true);
        }

        setLastScrollY(currentScrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    ////////////////////////////scroll nav hide end /////////////////

    return (
        <>
            <Helmet>
                <title>Contact Us | Sandip electronics  and Automation Pune Office</title>
                <meta name="description" content="Have questions about our Solar Pump Controllers or ATS? Contact Sandip electronics  and Automation today for sales inquiries, technical support, or partnership opportunities." />
                <meta name="keywords" content="Sandip electronics  contact number, automation company  Pune(India) address, solar pump controller dealer, SEA technical support email" />
                <meta property="og:title" content="Get in Touch with Sandip electronics  and Automation" />
                <meta property="og:description" content="Reach out to our expert team for custom automation solutions and reliable technical support." />
                <meta property="og:image" content="https://seaiot.in/images/contact-us-banner.jpg" />
                <meta property="og:url" content="https://seaiot.in/contact" />
                <meta property="og:type" content="website" />
            </Helmet>

            <div>
                <div className={`AppA ${isVisible ? "visible" : "hidden"}`}>
                    <div className="mylogo">
                        <div className="logo-container">
                            <Link to="/" className="cursor-pointer">
                                <img src={logo} alt="Logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="bar-container">
                        <Bar1 />
                    </div>
                </div>

                <div className="connect" >
                </div>
                <div className="contactus p-2 m-1" >
                    <div className="contactustext">
                        <h1 className="" style={{ zIndex: '25px', }} >
                            Contact us
                        </h1>
                        <p>
                            Get in touch and ask us anything. The difference between bookkeeping and accounting, can you start a company from madagascar, which business literature our CEO prefers - we answer it all.
                        </p>
                    </div>

                    <div class="grid grid-cols-12 p-0 m-0 sm:m-1 sm:p-2">
                        <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 item-center">
                            <div className="contactus1">
                                <div className="flex justify-center p-2" style={{ color: '#005E70' }}>
                                    <h1>Enquiry Form</h1>
                                </div>

                                <div>

                                    <div className="flex w-full flex-wrap md:flex-nowrap mb-6 md:mb-0 gap-4 p-2 mt-4">

                                        <div className="w-full" style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Input
                                                label="Name"
                                                placeholder="Enter your Name"
                                                type="text"
                                                name="name" // Ensure you have a name attribute
                                                variant="bordered"
                                                value={formData.name}
                                                classNames={{
                                                    inputWrapper: errors.name ? "border border-red-500" : "border border-default-500"
                                                }}
                                                isRequired
                                                onChange={handlechnage} // Corrected the function name
                                            />

                                            {errors.name && <span className="text-red-500">{errors.name}</span>}
                                        </div>

                                        <div className="w-full" style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Input label="Address"
                                                placeholder="Enter email Address"
                                                type="text"
                                                name='address'
                                                variant="bordered"
                                                value={formData.address}
                                                classNames={{
                                                    inputWrapper: errors.name ? "border border-red-500" : "border border-default-500"
                                                }}
                                                isRequired
                                                onChange={handlechnage} />

                                            {errors.address && <span className="text-red-500">{errors.address}</span>}
                                        </div>
                                    </div>

                                    <div className="flex w-full flex-wrap md:flex-nowrap mb-6 md:mb-0 gap-4 mt-8 p-1">
                                        <div className="w-full" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                            <Input label="Phone"
                                                placeholder="Enter your Mobail"
                                                type="text"
                                                name="phone"
                                                variant="bordered"
                                                value={formData.phone}
                                                isRequired
                                                classNames={{
                                                    inputWrapper: errors.name ? "border border-red-500" : "border border-default-500"
                                                }}
                                                onChange={handlechnage} />
                                            {errors.phone && <span className="text-red-500">{errors.phone}</span>}
                                        </div>

                                        <div className="w-full" style={{ display: 'flex', flexDirection: 'column' }}>

                                            <Input label="Email"
                                                placeholder="Enter your email"
                                                type="text"
                                                name='email'
                                                variant="bordered"
                                                value={formData.email}
                                                classNames={{
                                                    inputWrapper: errors.name ? "border border-red-500" : "border border-default-500"
                                                }}
                                                isRequired
                                                onChange={handlechnage} />
                                            {errors.email && <span className="text-red-500">{errors.email}</span>}
                                        </div>

                                    </div>

                                    <div className="flex w-full flex-wrap  mt-8 p-2">

                                        <Textarea
                                            isClearable
                                            className="max-w-xxl"
                                            // defaultValue="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                                            label="Description"
                                            placeholder="Description"
                                            name='description'
                                            classNames={{
                                                inputWrapper: errors.name ? "border border-red-500" : "border border-default-500"
                                            }}
                                            value={formData.description}
                                            onChange={handlechnage}
                                            variant="bordered"
                                        // eslint-disable-next-line no-console
                                        // onClear={() => console.log("textarea cleared")}
                                        />
                                    </div>
                                </div>

                                <div className="flex justify-center p-2">
                                    <Button color="primary" onClick={handleSubmit}>Send Your Enquiry Form</Button>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 item-center" >
                            <div className="contactus2">
                                <div className="flex justify-center p-2" style={{ color: '#005E70' }}>
                                    <h1>Contact Info</h1>
                                </div>

                                <div class="grid grid-cols-12 p-2">
                                    <div class="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-7 p-2" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', color: '#005E70' }}>
                                        <div class="grid grid-cols-12 items-center">
                                            <div class="col-span-3 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 flex items-center">
                                                <Phone />
                                            </div>

                                            <div class="col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                                <div class="flex flex-col">
                                                    <p class="text[#166275]">Support Team</p>
                                                    <h3 class="text-[#10323A] font-semibold">7721917812</h3>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="grid grid-cols-12 items-center mt-2">

                                            <div class="col-span-3 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 flex items-center">
                                                <Phone />
                                            </div>

                                            <div class="col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                                <div class="flex flex-col">
                                                    <p class="text[#166275]">sales</p>
                                                    <h3 class="text-[#10323A] font-semibold">8055607812</h3>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="grid grid-cols-12 items-center mt-2">
                                            <div class="col-span-3 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 flex items-center">
                                                <Message />
                                            </div>

                                            <div class="col-span-4 sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                                <div class="flex flex-col">
                                                    <p class="text-[#166275]">Sales Mail</p>
                                                    <h3 class="text-[#10323A]">info_sea_in@yahoo.com</h3>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="grid grid-cols-12 items-center mt-2">
                                            <div class="col-span-3 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 flex items-center">
                                                <Message />
                                            </div>
                                            <div class="col-span- sm:col-span-4 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                                <div class="flex flex-col">
                                                    <p class="text-[#166275]">Support Mail</p>
                                                    <h3 class="text-black font-semibold">
                                                        <a href="https://support@seaiot.in" class="text-[#10323A]">
                                                            support@seaiot.in
                                                        </a>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-5 p-2">
                                        <b class="text-[#166275]">Address:</b>
                                        <h3 class="text-[#10323A] font-semibold mt-2 text-h3tag">
                                            S No 116, R Cube, Office No 211, AtulNagar Phase I,
                                            Warje, Pune, Maharashtra 411058
                                        </h3>
                                        <div className="" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: '95px', marginBottom: '25px' }}>
                                            <a >
                                                <img src={Qr} alt="Conversation" name="Conversation" style={{ height: '100%', width: '150px', cursor: "pointer" }}
                                                    onClick={() => window.open(whatsappUrl, "_blank")} />
                                            </a>
                                            <p className="mt-1 mb-1 p-1" class='text-[#3199B2]'>click to visit whatsapp</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="p-1">
                    <ContactUs />
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default Contact_Us;

